(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.HeikoaDimensions = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  const SIZE_OPTION_PATTERN = /(taille|size|dimension|dimensions|format)/i;

  function numberToCentimeters(value, unit) {
    const number = Number(String(value).replace(',', '.'));
    if (!Number.isFinite(number) || number <= 0) return null;
    return unit && unit.toLowerCase() === 'm' ? number * 100 : number;
  }

  function parseDimensions(value) {
    if (typeof value !== 'string') return null;
    const normalized = value
      .normalize('NFKC')
      .replace(/[×✕✖]/g, 'x')
      .replace(/\s+/g, ' ')
      .trim();

    const rectangle = normalized.match(
      /(\d+(?:[.,]\d+)?)\s*(cm|m)?\s*x\s*(\d+(?:[.,]\d+)?)\s*(cm|m)?/i,
    );
    if (rectangle) {
      const sharedUnit = rectangle[4] || rectangle[2] || 'cm';
      const widthCm = numberToCentimeters(rectangle[1], rectangle[2] || sharedUnit);
      const lengthCm = numberToCentimeters(rectangle[3], rectangle[4] || sharedUnit);
      if (!widthCm || !lengthCm) return null;
      return { widthCm, lengthCm, shape: 'rectangle', source: rectangle[0] };
    }

    const round = normalized.match(/(?:ø|diam(?:è|e)tre)?\s*(\d+(?:[.,]\d+)?)\s*(cm|m)/i);
    if (round) {
      const diameterCm = numberToCentimeters(round[1], round[2]);
      if (!diameterCm) return null;
      return {
        widthCm: diameterCm,
        lengthCm: diameterCm,
        shape: 'round',
        source: round[0],
      };
    }
    return null;
  }

  function parseVariantDimensions(variant, optionNames) {
    if (!variant) return null;
    const options = Array.isArray(variant.options) ? variant.options : [];
    const names = Array.isArray(optionNames) ? optionNames : [];
    const prioritized = [];
    options.forEach(function (value, index) {
      if (SIZE_OPTION_PATTERN.test(names[index] || '')) prioritized.push(value);
    });
    const candidates = prioritized.concat(options, [variant.title || '']);
    for (const candidate of candidates) {
      const dimensions = parseDimensions(candidate);
      if (dimensions) return dimensions;
    }
    return null;
  }

  function ratioForShape(dimensions, shape) {
    if (!dimensions) return 1;
    if (shape === 'round' || dimensions.shape === 'round') return 1;
    return Math.max(dimensions.widthCm, dimensions.lengthCm) /
      Math.min(dimensions.widthCm, dimensions.lengthCm);
  }

  function formatDimensions(dimensions) {
    if (!dimensions) return '';
    const format = function (number) {
      return Number.isInteger(number) ? String(number) : String(Math.round(number * 10) / 10);
    };
    if (dimensions.shape === 'round') return `Ø ${format(dimensions.widthCm)} cm`;
    return `${format(dimensions.widthCm)} × ${format(dimensions.lengthCm)} cm`;
  }

  return {
    formatDimensions,
    parseDimensions,
    parseVariantDimensions,
    ratioForShape,
  };
});
